import React, { PureComponent } from 'react';
import { Col, Form } from 'react-bootstrap';
import { Shapes } from '../../models/entities';

class AccountDataForm extends PureComponent {
  constructor(props) {
    super(props);
    if (props.accountData) {
      this.state = { ...props.accountData };
    } else {
      this.state = {};
    }
  }

  render = () => {
    const {
      accountNumber, firstName, lastName, streetDirection,
      streetSuffix, unitType, unitNumber, city, state,
    } = this.state;

    return (
      <Form>
        <Form.Row>
          <Col>
            <Form.Group controlId="accountNumber">
              <Form.Label>Account Number</Form.Label>
              <Form.Control readOnly type="text" value={accountNumber || '-'} />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group controlId="firstName">
              <Form.Label>First Name</Form.Label>
              <Form.Control readOnly type="text" value={firstName || '-'} />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group controlId="lastName">
              <Form.Label>Last Name</Form.Label>
              <Form.Control readOnly type="text" value={lastName || '-'} />
            </Form.Group>
          </Col>
        </Form.Row>
        <Form.Row>
          <Col>
            <Form.Group controlId="streetDirection">
              <Form.Label>Street Direction</Form.Label>
              <Form.Control readOnly type="text" value={streetDirection || '-'} />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group controlId="streetSuffix">
              <Form.Label>Street Suffix</Form.Label>
              <Form.Control readOnly type="text" value={streetSuffix || '-'} />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group controlId="unitType">
              <Form.Label>Unit Type</Form.Label>
              <Form.Control readOnly type="text" value={unitType || '-'} />
            </Form.Group>
          </Col>
        </Form.Row>
        <Form.Row>
          <Col>
            <Form.Group controlId="unitNumber">
              <Form.Label>Unit Number</Form.Label>
              <Form.Control readOnly type="text" value={unitNumber || '-'} />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group controlId="city">
              <Form.Label>City</Form.Label>
              <Form.Control readOnly type="text" value={city || '-'} />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group controlId="state">
              <Form.Label>State</Form.Label>
              <Form.Control readOnly type="text" value={state || '-'} />
            </Form.Group>
          </Col>
        </Form.Row>
      </Form>
    );
  }
}

AccountDataForm.propTypes = {
  accountData: Shapes.ACCOUNT_DATA,
};

AccountDataForm.defaultProps = {
  accountData: null,
};

export default AccountDataForm;
